import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LocalCompany } from '@models/company.model';
import { LocalUser } from '@models/user.model';
import { AuthService } from '@services/auth.service';
import { DataStorageKey, DataStorageService } from '@services/data-storage.service';
import { firstValueFrom } from 'rxjs';

export const sessionGuard = async (_: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const dataStorageService = inject(DataStorageService);
  const localUser = await firstValueFrom(dataStorageService.get<LocalUser>(DataStorageKey.LocalUser));
  const localCompany = await firstValueFrom(dataStorageService.get<LocalCompany>(DataStorageKey.LocalCompany));
  const session = await firstValueFrom(authService.getSession());
  if (session?.userPlatformRole === 'admin') {
    return true;
  }
  if (session !== null) {
    if (!localUser?.profileDataCompleted &&
      !routerStateSnapshot.url.startsWith('/auth/onboarding')) {
      return router.parseUrl('/auth/onboarding');
    }
    if (localUser?.profileDataCompleted &&
      !localCompany?.profileDataCompleted &&
      !routerStateSnapshot.url.startsWith('/auth/create-company')) {
      return router.parseUrl('/auth/create-company');
    }
    if (localUser?.profileDataCompleted &&
      localCompany?.profileDataCompleted &&
      !localCompany?.subscriptionSelected &&
      !routerStateSnapshot.url.startsWith('/auth/company-subscription')) {
      return router.parseUrl('/auth/company-subscription');
    }
    if (localUser?.profileDataCompleted &&
      localCompany?.profileDataCompleted &&
      localCompany?.subscriptionSelected &&
      routerStateSnapshot.url.startsWith('/auth')) {
      return router.parseUrl('/dashboard/home');
    }
    if (!session?.modules?.includes('quotes') && routerStateSnapshot.url.startsWith('/dashboard/quotes')) {
      return router.parseUrl('/dashboard/home');
    }
  } else {
    if (!routerStateSnapshot.url.startsWith('/auth/sign-in') &&
      !routerStateSnapshot.url.startsWith('/auth/otp-sent') &&
      !routerStateSnapshot.url.startsWith('/auth/verify') &&
      !routerStateSnapshot.url.startsWith('/auth/verify-invitation')) {
      dataStorageService.set<string>(DataStorageKey.RedirectUrl, routerStateSnapshot.url);
      return router.createUrlTree(['/auth/sign-in']);
    }
  }
  return true;
};
